import axios from 'axios'
import store from '../store'

// 普通接口
export function request(config) {
  const instance = axios.create({
    baseURL: "https://sdk-dept1.hnguangyi.cn/",
    timeout: 10000,
    method: "POST",
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
  instance.interceptors.request.use(res => {
    // console.log(res);
    // 打印请求的地址，以及请求参数
    // console.log(res.baseURL+res.url);
    // console.log(res.params);
    // 显示加载中
    store.commit('switchLoading', true)
    return res
  }, error =>{})
  
  instance.interceptors.response.use(res => {
    // 打印响应返回数据，完整的还没经过处理的
    // console.log(res);
    // 隐藏加载中
    store.commit('switchLoading', false)
    // console.log(res);
    //判断 success的结果是 false 或 true
    if(res.status == 200){
      //结果为true 那么返回去掉外层data之后的数据
      if (res.data.code == 0) {
        return res.data.data
      }else if(8030 == res.data.code || 5010 == res.data.code){
          // 8030:该账号未绑定提取方式 , 5010:红包余额不足,  
          // 这里不弹出提示窗口了，直接交由领取的时候去处理
      }else if(5012 == res.data.code){
        // 5012: V2红包领取时的错误
        return Promise.reject(new Error(res.data.code + res.data.msg))
      }else if(4007 == res.data.code){
        // 4007 快速登录验证失败
        return Promise.reject(new Error(res.data.msg))
      }
      else{
        // 这里表示接口请求返回的code不为0，就是有问题，价格弹窗提示吧
        // let payload = {"showOrHide": true, "alertMessage": res.data.msg}
        // store.commit('switchAlert', payload)
        // Toast 提示
        store.commit("switchToast",{"showOrHide": true, "toastMessage": res.data.msg});
      }
      // return res.data
      //结果为false 返回message中的错误信息
      return Promise.reject(new Error(res.data.msg))
    } else {
      //结果为false 返回message中的错误信息
      return Promise.reject(new Error(res.data.msg))
    }
  }, error =>{})
  return instance(config)
}

// // 红包相关接口
// export function rbrequest(config) {
//   const instance = axios.create({
//     baseURL: "https://sdk-dept1.hnguangyi.cn/rebate/?",
//     timeout: 10000,
//     headers:{
//       'Content-Type': 'application/x-www-form-urlencoded',
//     }
//   })
//   return instance(config)
// }



// 下面这些是直接使用axios调用的
// let storeCommomParams = this.$store.getters.getCommomParams;
// console.log(storeCommomParams)
// const instance = axios.create({
//   baseURL: "https://sdk-dept1.hnguangyi.cn/",
//   timeout: 10000,
//   headers:{
//     'Content-Type': 'application/x-www-form-urlencoded',
//     // "Access-Control-Allow-Origin":"*"
//   }
// })
// let signParams = getRequestParams({},storeCommomParams);
// console.log(signParams);
// let param = 'data='+signParams
// instance.post("common/cross_index.php?ct=system&ac=init",param)
// .then(res =>{
//   console.log("成功打印。。。");
//   console.log(res)
// }).catch(error =>{
//   console.log("catch 错误");
//   console.log(error)
// })

// 测试的api
// axios({
      //   url:"https://jsonplaceholder.typicode.com/posts",
      //   method: 'POST',
      //   data:{
      //     title: 'foo',
      //     body: 'bar',
      //     userId: 1,
      //   }
      // }).then(res =>{
      //   console.log(res)
      // })





// WEBPACK FOOTER //
// ./src/normal/network/request.js